export class TimecodeHelpers {
  static FPS = 25;
  static timecodeDiffInFrames(start: string, end: string) {
    const startT = this.timecodeToFrames(start);
    const endT = this.timecodeToFrames(end);
    return startT > endT ? startT - endT : endT - startT;
  }

  static timecodeToFrames(tc: string) {
    if (tc == null) {
      return NaN;
    }
    const digits = tc.split(':');
    const frames = +digits[3];
    const seconds = +digits[2];
    const minutes = +digits[1];
    const hours = +digits[0];

    return frames + seconds * this.FPS + minutes * this.FPS * 60 + hours * this.FPS * 3600;
  }

  static framesToTimecode(frames: number) {
    const frameStamp = frames % this.FPS;
    const secStamp = Math.floor(frames / this.FPS) % 60;
    const minStamp = Math.floor(frames / 60 / this.FPS) % 60;
    const hStamp = Math.floor(frames / 3600 / this.FPS) % 24;

    const p = (v) => `${v}`.padStart(2, '0');

    return `${p(hStamp)}:${p(minStamp)}:${p(secStamp)}:${p(frameStamp)}`;
  }
}
